import { Flex, Text } from "@gravity-ui/uikit";
import { useMemo } from "react";

interface PasswordStrengthProps {
  conditions: Record<string, boolean>;
  password?: string | null;
}

const getStrength = (countValid: number) => {
  if (countValid <= 2)
    return { color: "var(--g-color-text-danger)", title: "Не надежный" };
  if (countValid < 4)
    return { color: "var(--g-color-text-warning)", title: "Простой" };
  if (countValid >= 4)
    return { color: "var(--g-color-text-positive)", title: "Надежный" };

  return { color: "var(--g-color-base-generic)", title: "Не надежный" };
};

export const PasswordStrength = ({
  conditions,
  password,
}: PasswordStrengthProps) => {
  const validCount = useMemo(
    () =>
      Object.values(conditions).reduce(
        (acc, value) => (value ? acc + 1 : acc),
        0,
      ),
    [conditions],
  );

  const strength = getStrength(validCount);

  if (!password) return null;

  return (
    <Flex direction={"column"} gap={2} style={{ marginTop: 8 }}>
      <Flex gap={"0.5"}>
        {Object.keys(conditions).map((condition, index) => {
          return (
            <div
              key={condition}
              style={{
                backgroundColor:
                  index < validCount
                    ? strength.color
                    : "var(--g-color-base-generic)",
                height: 6,
                flexGrow: 1,
                borderRadius: 4,
              }}
            />
          );
        })}
      </Flex>

      <Text variant="subheader-1">
        Сложность пароля:{" "}
        <span style={{ color: strength.color }}>{strength.title}</span>
      </Text>
    </Flex>
  );
};
